import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from "@angular/core";
import { Status } from "@lantern/app/models/status";

@Component({
  selector: "ta-icon",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @Input()
  get icon(): string {
    return this._icon;
  }
  set icon(value: string) {
    if (this._icon === value) {
      return;
    }
    let oldIcon = this._icon;
    this._icon = value;

    if (oldIcon != null) {
      this.classNames.delete(`icon--${oldIcon}`);
    }
    this.classNames.add(`icon--${value}`);
    this.updateClasses();
  }
  private _icon: string;

  // For adding extra classes for status colors
  @Input()
  get status(): Status {
    return this._status;
  }
  set status(val: Status) {
    if (val === this._status) {
      return;
    }
    let oldStatus = this._status;
    this._status = val;
    this.classNames.delete(`icon--${oldStatus}`);
    this.classNames.add(`icon--${this._status}`);
    this.updateClasses();
  }
  private _status: Status;

  @HostBinding("attr.class")
  classAttr: string = "icon";

  @Input()
  get spin(): boolean {
    return this._spin;
  }
  set spin(value: boolean) {
    value = value != null && value !== false;
    if (this.spin === value) {
      return;
    }
    this._spin = value;

    if (value) {
      this.classNames.add("icon--spin");
    } else {
      this.classNames.delete("icon--spin");
    }
    this.updateClasses();
  }
  private _spin: boolean = false;

  private classNames: Set<string> = new Set(["icon"]);

  private updateClasses(): void {
    this.classAttr = Array.from(this.classNames).join(" ");
  }
}
